<template>
  <span>
    <b-button v-if="!withoutButton" size="sm" v-b-modal="'modalShippingMap' + shipping.id" v-translate>
      Shipping Map
    </b-button>
    <b-modal size="xl" :id="'modalShippingMap' + shipping.id" :ref="'modalShippingMap' + shipping.id" hide-footer @hidden="emitHidden">
      <div slot="modal-title" v-translate>Shipping Map</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <shipping-map v-if="shipping" :update-every="updateEvery" :shipping-id="shipping.id" :popup-type="popupType" :with-tracking="withTracking" />
    </b-modal>
  </span>
</template>

<script>
import ShippingMap from '@/components/Maps/ShippingMap'

export default {
  name: 'ModalShippingMap',
  components: {
    ShippingMap
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    },
    withTracking: {
      type: Boolean,
      default: false
    },
    popupType: {
      type: String,
      default: 'shipping'
    },
    withoutButton: {
      type: Boolean,
      default: false
    },
    updateEvery: {
      type: [Number, String],
      default: null
    }
  },
  methods: {
    emitHidden() {
      this.$emit('hidden', true)
    }
  }
}
</script>
